import { Box } from '@node-space/ui-components'
import { EarnDetailsLayout } from '../../components/EarnDetailsLayout'
import { EarnEmbeddedDetailsCustomerSummary } from '../../components/embedded/EarnEmbeddedDetailsCustomerSummary'
import { EarnEmbeddedDetailsMerchantSummary } from '../../components/embedded/EarnEmbeddedDetailsMerchantSummary'
import { useEarnEmbeddedDetailsData } from '../../hooks/details/useEarnEmbeddedDetailsData'
import { EARN_DETAILS_STATE, UseEarnDetailsDataHandlers } from '../../types/detailsState'

export interface EarnEmbeddedDetailsViewProps extends UseEarnDetailsDataHandlers {
  portfolioId: string | undefined
}

export const EarnEmbeddedDetailsView = ({
  portfolioId,
  onDeposit,
  onWithdraw,
}: EarnEmbeddedDetailsViewProps) => {
  const viewData = useEarnEmbeddedDetailsData(portfolioId, { onDeposit, onWithdraw })

  return (
    <EarnDetailsLayout portfolioId={portfolioId} viewData={viewData}>
      {viewData.detailsState === EARN_DETAILS_STATE.READY && (
        <Box flexCol gap={16} align="start" className=" lg:flex-row">
          <EarnEmbeddedDetailsMerchantSummary
            earnRate={viewData.earnRate}
            allocatedFunds={viewData.summary.allocatedFunds}
            allocationEarnings={viewData.totalEarnings.allocationEarnings}
            totalEarnings={viewData.totalEarnings.totalEarnings}
            customerEarnings={viewData.totalEarnings.customerEarnings}
          />
          <EarnEmbeddedDetailsCustomerSummary
            customerEarnRate={viewData.customerEarnRate}
            customerEarningBalance={viewData.customerSummary.customerEarningBalance}
            customerPaidAmount={viewData.customerSummary.customerPaidAmount}
            epcTakesEarn={viewData.epcTakesEarn}
            isStatisticsLoading={viewData.isStatisticsLoading}
          />
        </Box>
      )}
    </EarnDetailsLayout>
  )
}
